/**
 * ResponsavelFilial
 * @author Simpli CLI generator
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import ResponsavelFilialSchema from '@/schema/ResponsavelFilial.schema'

export default class ResponsavelFilial extends Resource {
  readonly $name: string = 'ResponsavelFilial'

  readonly $endpoint: string = '/user/responsavel-filial{/id}'

  get $schema() {
    return ResponsavelFilialSchema(this)
  }

  get $id() {
    return this.idFilialPk
  }
  set $id(val: ID) {
    this.idFilialPk = val
  }

  idFilialPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(255)
  cnpjBase: string = ''

  async persistResponsavelFilial(model?: ResponsavelFilial, spinner = 'persistResponsavelFilial') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/responsavel-filial`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getResponsavelFilial(id: number, spinner = 'getResponsavelFilial') {
    const fetch = async () => await this.GET(`/user/responsavel-filial/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
